// PromoCodeInput.js
import React, { useState, useContext } from 'react';
import api from '../api';
import { AuthContext } from '../context/AuthContext';
import './PromoCodeInput.css';

function PromoCodeInput({ productId, onRedeemed, disabled = true }) {
  const { user } = useContext(AuthContext);
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleValidate = async () => {
    if (!code.trim() || disabled) return;

    setLoading(true);
    setMessage('');

    try {
      // First validate the promo code
      const validateResponse = await api.post('/api/promo/validate/', {
        code: code.trim(),
        product_id: productId
      });

      if (validateResponse.data.valid) {
        // Code is valid, now redeem it
        const redeemResponse = await api.post('/api/redeem/', {
          code: code.trim(),
          product_id: productId,
          email: user?.email  // Include email for backend authentication
        });

        setMessage('Success! Product redeemed. Check your downloads.');
        setMessageType('success');
        
        if (onRedeemed) {
          onRedeemed(redeemResponse.data);
        }
      } else {
        setMessage(validateResponse.data.error || 'Invalid promo code');
        setMessageType('error');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Failed to validate code';
      setMessage(errorMsg);
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    // Encode current URL to return after login
    const currentPath = window.location.pathname;
    const redirectParam = encodeURIComponent(currentPath);
    
    return (
      <div className="promo-section promo-disabled">
        <h3>Have a Promo Code?</h3>
        <p className="promo-login-prompt">
          <a href={`/login?redirect=${redirectParam}`}>Log in</a> or <a href={`/register?redirect=${redirectParam}`}>register</a> to download the EPUB.
        </p>
        <div className="promo-input-group">
          <input
            type="text"
            value=""
            placeholder="Promo codes temporarily disabled"
            className="promo-input"
            disabled={true}
          />
          <button
            disabled={true}
            className="promo-btn"
          >
            Redeem
          </button>
        </div>
        <p className="promo-note">
          <em>Note: Promo codes are not currently required. Just log in to download!</em>
        </p>
      </div>
    );
  }

  return (
    <div className={`promo-section ${disabled ? 'promo-disabled' : ''}`}>
      <h3>Have a Promo Code?</h3>
      <div className="promo-input-group">
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder={disabled ? "Promo codes temporarily disabled" : "Enter promo code to enable Download button."}
          className="promo-input"
          disabled={loading || disabled}
        />
        <button
          onClick={handleValidate}
          disabled={loading || !code.trim() || disabled}
          className="promo-btn"
        >
          {loading ? 'Validating...' : 'Redeem'}
        </button>
      </div>
      {disabled && (
        <p className="promo-note">
          <em>Note: Promo codes are not currently required. Use the Download button above!</em>
        </p>
      )}
      {message && (
        <div className={`promo-message ${messageType}`}>
          {message}
        </div>
      )}
    </div>
  );
}

export default PromoCodeInput;
